import { ASDRatchets } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

export const asdModels: Record<string, string[]> = {
    'ASD_SONY_3MON_0.37_2021': ['AMU_ALEXA_PSM_SONY_ASD_SUBSCRIPTION', 'AMU_ALEXA_PSM_SONY_ASD_UPGRADES'],
    'ASD_SONYJP_3MON_0.35_2021': ['AMU_ALEXA_PSM_SONY_JP_ASD_SUBSCRIPTION', 'AMU_ALEXA_PSM_SONY_JP_ASD_UPGRADES'],
    'ASD_UMG_3MON_0.2_2021': ['AMU_ALEXA_PSM_UMG_ASD_SUBSCRIPTION', 'AMU_ALEXA_PSM_UMG_ASD_UPGRADES'],
    'ASD_WMG_3MON_0.3': ['AMU_ALEXA_PSM_WMG_ASD_SUBSCRIPTION', 'AMU_ALEXA_PSM_WMG_ASD_UPGRADES']
};

export const asdInputDefinitionsThresholdsMap: Record<string, ASDRatchets> = {
    AMU_ALEXA_PSM_UMG_ASD_SUBSCRIPTION: {
        tier2Threshold: 0.2,
        tier3Threshold: undefined,
        thresholdOperator: '>=',
        rollingMonthlyAverage: 3
    },
    AMU_ALEXA_PSM_WMG_ASD_SUBSCRIPTION: {
        tier2Threshold: 0.3,
        tier3Threshold: 0.35,
        thresholdOperator: '>=',
        rollingMonthlyAverage: 3
    },
    AMU_ALEXA_PSM_SONY_ASD_SUBSCRIPTION: {
        tier2Threshold: 0.37,
        tier3Threshold: undefined,
        thresholdOperator: '>',
        rollingMonthlyAverage: 3
    },
    AMU_ALEXA_PSM_SONY_JP_ASD_SUBSCRIPTION: {
        tier2Threshold: 0.35,
        tier3Threshold: undefined,
        thresholdOperator: '>=',
        rollingMonthlyAverage: 3
    },
    AMU_ALEXA_PSM_UMG_ASD_UPGRADES: {
        tier2Threshold: 0.2,
        tier3Threshold: undefined,
        thresholdOperator: '>=',
        rollingMonthlyAverage: 3
    },
    AMU_ALEXA_PSM_WMG_ASD_UPGRADES: {
        tier2Threshold: 0.3,
        tier3Threshold: 0.35,
        thresholdOperator: '>=',
        rollingMonthlyAverage: 3
    },
    AMU_ALEXA_PSM_SONY_ASD_UPGRADES: {
        tier2Threshold: 0.37,
        tier3Threshold: undefined,
        thresholdOperator: '>',
        rollingMonthlyAverage: 3
    },
    AMU_ALEXA_PSM_SONY_JP_ASD_UPGRADES: {
        tier2Threshold: 0.35,
        tier3Threshold: undefined,
        thresholdOperator: '>=',
        rollingMonthlyAverage: 3
    }
};
